<template>
    <front-layout title="Questionário Satisfação">
        <div class="bg-texture pt-60 pb-40">
            <div class="container px-4 mx-auto">
            <h1 class="font-bold text-2xl text-gray-400 mb-12"><strong>Questionário de Satisfação</strong></h1>
            <div v-if="enable == true">
                <p>Prezado cliente,<br>a <strong>Pessoalform</strong> tem como compromisso a procura da melhoria contínua, de modo a criar novas alternativas num atendimento cada vez mais eficaz.<br>A sua opinião é fundamental para melhorar a qualidade dos nossos serviços!<br>
                    Se tiver dificuldades no envio do questionário, utilize o <a href="https://www.google.com/intl/pt-PT/chrome/" target="_blank" class="underline">Google Chrome</a>, ou o <a href="https://www.mozilla.org/pt-PT/firefox/new/" target="_blank" class="underline">Mozilla Firefox</a>, ou <a :href="route('contactos')" class="underline">contacte-nos</a></p>

                <h4 class="text-sm font-bold mt-8">IDENTIFICAÇÃO DA EMPRESA</h4>

                <div class="p-10 rounded-lg bg-white mt-4 shadow">
                    <!-- empresa -->
                    <div class="flex flex-row items-center space-x-4 w-full">
                        <div class="flex-1">Nome Empresa <jet-input type="text" v-model="form.empresa" class="w-full" /><jet-input-error :message="form.errors.empresa" /></div>
                        
                        <div class="flex-1">Email <jet-input type="email" v-model="form.email" class="w-full" /> <jet-input-error :message="form.errors.email" /></div>                    
                    </div>

                     <!-- responsável -->
                    <div class="flex flex-row items-center space-x-4 w-full mt-4">
                        <div class="flex-1">Preenchido por <jet-input type="text" v-model="form.nome" class="w-full" /><jet-input-error :message="form.errors.nome" /></div>
                        <div class="flex-1">Data <jet-input type="text" v-model="form.date" class="w-full" /> <jet-input-error :message="form.errors.date" /></div>                    
                    </div>
                </div>

                <h4 class="text-sm font-bold mt-8">QUALIDADE DOS SERVIÇOS PRESTADOS</h4>

                <div class="p-10 rounded-lg bg-white mt-4 shadow">
                    <h4 class="float-right text-right"><small>Assinale as suas respostas<br/><strong>(1) Insatisfeito - (4) Muito Satisfeito</strong></small></h4>

                    <table class="w-full text-lg table-auto">
                        <tbody>
                            <tr class="w-full">
                                <td>1. Rapidez de resposta a solicitações</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.rapidez" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="rapidez" value="1" v-model="form.rapidez" class="rounded-full" />
                                        <jet-label for="rapidez" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="rapidez" value="2" v-model="form.rapidez" class="rounded-full" />
                                        <jet-label for="rapidez" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="rapidez" value="3" v-model="form.rapidez" class="rounded-full" />
                                        <jet-label for="rapidez" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="rapidez" value="4" v-model="form.rapidez" class="rounded-full" />
                                        <jet-label for="rapidez" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>2. Rigor e qualidade de informacão/esclarecimentos</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.rigor" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="rigor" value="1" v-model="form.rigor" class="rounded-full" />
                                        <jet-label for="rigor" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="rigor" value="2" v-model="form.rigor" class="rounded-full" />
                                        <jet-label for="rigor" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="rigor" value="3" v-model="form.rigor" class="rounded-full" />
                                        <jet-label for="rigor" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="rigor" value="4" v-model="form.rigor" class="rounded-full" />
                                        <jet-label for="rigor" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>3. Periocidade das visitas/contactos</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.periocidade" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="periocidade" value="1" v-model="form.periocidade" class="rounded-full" />
                                        <jet-label for="periocidade" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="periocidade" value="2" v-model="form.periocidade" class="rounded-full" />
                                        <jet-label for="periocidade" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="periocidade" value="3" v-model="form.periocidade" class="rounded-full" />
                                        <jet-label for="periocidade" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="periocidade" value="4" v-model="form.periocidade" class="rounded-full" />
                                        <jet-label for="periocidade" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>4. Simpatia/cortesia no atendimento</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.cortesia" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="cortesia" value="1" v-model="form.cortesia" class="rounded-full" />
                                        <jet-label for="cortesia" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="cortesia" value="2" v-model="form.cortesia" class="rounded-full" />
                                        <jet-label for="cortesia" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="cortesia" value="3" v-model="form.cortesia" class="rounded-full" />
                                        <jet-label for="cortesia" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="cortesia" value="4" v-model="form.cortesia" class="rounded-full" />
                                        <jet-label for="cortesia" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>5. Prazo de entrega da documentação</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.prazo" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="prazo" value="1" v-model="form.prazo" class="rounded-full" />
                                        <jet-label for="prazo" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="prazo" value="2" v-model="form.prazo" class="rounded-full" />
                                        <jet-label for="prazo" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="prazo" value="3" v-model="form.prazo" class="rounded-full" />
                                        <jet-label for="prazo" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="prazo" value="4" v-model="form.prazo" class="rounded-full" />
                                        <jet-label for="prazo" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>6. Qualidade da documentação(Faturas, Contratos,...)</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.documentacao" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="documentacao" value="1" v-model="form.documentacao" class="rounded-full" />
                                        <jet-label for="documentacao" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="documentacao" value="2" v-model="form.documentacao" class="rounded-full" />
                                        <jet-label for="documentacao" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="documentacao" value="3" v-model="form.documentacao" class="rounded-full" />
                                        <jet-label for="documentacao" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="documentacao" value="4" v-model="form.documentacao" class="rounded-full" />
                                        <jet-label for="documentacao" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>7. Tratamento de divergências/reclamações</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.reclamacoes" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="reclamacoes" value="1" v-model="form.reclamacoes" class="rounded-full" />
                                        <jet-label for="reclamacoes" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="reclamacoes" value="2" v-model="form.reclamacoes" class="rounded-full" />
                                        <jet-label for="reclamacoes" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="reclamacoes" value="3" v-model="form.reclamacoes" class="rounded-full" />
                                        <jet-label for="reclamacoes" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="reclamacoes" value="4" v-model="form.reclamacoes" class="rounded-full" />
                                        <jet-label for="reclamacoes" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>


                            <tr class="w-full">
                                <td>8. Seleção de trabalhador de acordo com o pretendido</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.trabalhador" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="trabalhador" value="1" v-model="form.trabalhador" class="rounded-full" />
                                        <jet-label for="trabalhador" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="trabalhador" value="2" v-model="form.trabalhador" class="rounded-full" />
                                        <jet-label for="trabalhador" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="trabalhador" value="3" v-model="form.trabalhador" class="rounded-full" />
                                        <jet-label for="trabalhador" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="trabalhador" value="4" v-model="form.trabalhador" class="rounded-full" />
                                        <jet-label for="trabalhador" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>9. Desempenho dos trabalhadores temporários</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.desempenho" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="desempenho" value="1" v-model="form.desempenho" class="rounded-full" />
                                        <jet-label for="desempenho" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="desempenho" value="2" v-model="form.desempenho" class="rounded-full" />
                                        <jet-label for="desempenho" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="desempenho" value="3" v-model="form.desempenho" class="rounded-full" />
                                        <jet-label for="desempenho" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="desempenho" value="4" v-model="form.desempenho" class="rounded-full" />
                                        <jet-label for="desempenho" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>10. Assiduidade dos trabalhadores temporários</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.assiduidade" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="assiduidade" value="1" v-model="form.assiduidade" class="rounded-full" />
                                        <jet-label for="assiduidade" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="assiduidade" value="2" v-model="form.assiduidade" class="rounded-full" />
                                        <jet-label for="assiduidade" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="assiduidade" value="3" v-model="form.assiduidade" class="rounded-full" />
                                        <jet-label for="assiduidade" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="assiduidade" value="4" v-model="form.assiduidade" class="rounded-full" />
                                        <jet-label for="assiduidade" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>11. Relação qualidade/preço</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.qualidade" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="qualidade" value="1" v-model="form.qualidade" class="rounded-full" />
                                        <jet-label for="qualidade" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="qualidade" value="2" v-model="form.qualidade" class="rounded-full" />
                                        <jet-label for="qualidade" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="qualidade" value="3" v-model="form.qualidade" class="rounded-full" />
                                        <jet-label for="qualidade" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="qualidade" value="4" v-model="form.qualidade" class="rounded-full" />
                                        <jet-label for="qualidade" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>

                            <tr class="w-full">
                                <td>12. Satisfação global com o serviço</td>
                                <td class="float-right">
                                    <jet-input-error :message="form.errors.satisfacao" />
                                    <div class="flex flex-row items-center">
                                        <jet-input type="radio" name="satisfacao" value="1" v-model="form.satisfacao" class="rounded-full" />
                                        <jet-label for="satisfacao" class="mx-2 text-sm">1</jet-label>
                                        <jet-input type="radio" name="satisfacao" value="2" v-model="form.satisfacao" class="rounded-full" />
                                        <jet-label for="satisfacao" class="mx-2 text-sm">2</jet-label>
                                        <jet-input type="radio" name="satisfacao" value="3" v-model="form.satisfacao" class="rounded-full" />
                                        <jet-label for="satisfacao" class="mx-2 text-sm">3</jet-label>
                                        <jet-input type="radio" name="satisfacao" value="4" v-model="form.satisfacao" class="rounded-full" />
                                        <jet-label for="satisfacao" class="mx-2 text-sm">4</jet-label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    <div class="mt-4">
                        <p>13. Qual a principal característica que leva a manter a Pessoalform como parceira de negócio?</p>
                        <text-area-input v-model="form.caracteristica" rows="2" class="w-full"></text-area-input>
                        <jet-input-error :message="form.errors.caracteristica" />
                    </div>

                    <div class="mt-4">
                        <p>14. Qual a principal dificuldade sentida da parceria com a Pessoalform?</p>
                        <text-area-input v-model="form.dificuldade" rows="2" class="w-full"></text-area-input>
                        <jet-input-error :message="form.errors.dificuldade" />
                    </div>

                    <div class="mt-4">
                        <p>15. Recomendará a Pessoalform a outras Empresas?
                            <jet-input type="radio" name="recomenda" v-model="form.recomenda" value="sim" class="rounded-full" /> sim
                            <jet-input type="radio" name="recomenda" v-model="form.recomenda" value="não" class="rounded-full" /> Não <jet-input-error :message="form.errors.recomenda" /></p>

                    </div>

                </div>

      
    
                 <div class="p-10 rounded-lg bg-white mt-4 shadow">
                    <h4 class="font-bold text-sm">OPINIÕES/SUGESTÕES DE MELHORIA</h4>
                    <text-area-input v-model="form.opinioes" rows="4" class="w-full"></text-area-input>
                </div>

                <div class="mt-4 flex flex-row items-center">
                    <jet-checkbox v-model="form.rgpd" class="mr-2" value=""></jet-checkbox> Li e aceito a <a :href="route('pol_privacidade')" class="text-violet-500 underline"> Política de Privacidade</a>
                </div>
                 <jet-input-error :message="form.errors.rgpd" />

                <p class="text-right"><strong>Gratos pela sua colaboração!</strong></p>

                <jet-button @click.prevent="sendForm">Enviar</jet-button>
            </div>

            <div v-else>
                <div class="bg-white shadow rounded-lg p-8 flex flex-row items-center space-x-4 inline-flex">
                    <p>Pin de acesso</p>
                    <input type="text" v-model="pin" class="rounded font-bold">
                    <button @click.prevent="ok" class="border rounded bg-gray-900 text-white py-2 px-4 font-bold">Ok</button>
                </div>
            </div>
            </div>
        </div>
    </front-layout>
</template>

<style>
    tr:nth-child(even){
        background: transparent;
    }
</style>

<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import TextAreaInput from '@/Jetstream/TextAreaInput.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetLabel from '@/Jetstream/Label.vue'

   
    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            Icon,
            JetInput,
            TextAreaInput,
            JetCheckbox,
            JetInputError,
            JetButton,
            JetLabel
        },
        props: {
        },
        data() {
            return {
                enable: false,
                pin: '',
                form: this.$inertia.form({
                    empresa: '',
                    nome: '',
                    email: '',
                    date: '',
                    rapidez: '',
                    rigor: '',
                    periocidade: '',
                    cortesia: '',
                    prazo: '',
                    documentacao: '',
                    reclamacoes: '',
                    trabalhador: '',
                    desempenho: '',
                    assiduidade: '',
                    qualidade: '',
                    satisfacao: '',
                    caracteristica: '',
                    dificuldade: '',
                    recomenda: '',
                    opinioes: '',
                    rgpd: ''
                })
            }
        },
        created() {
            let localPin = window.localStorage.getItem('pin'); 
            if(localPin == '6143') {
                this.enable = true
            }
        },
        methods: {
            ok() {
                window.localStorage.setItem('pin', this.pin);
                let localPin = window.localStorage.getItem('pin'); 
                this.$page.props.flash.error = ''

                if(localPin == '6143') {
                    this.enable = true
                } else {
                    this.pin = ''
                    this.$page.props.flash.error = 'Pin incorreto.Tente novamente'
                }
            },
            sendForm() {
                this.form.post(route('send.questionario'), {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.reset()
                    }
                })
            }
        }
    })
</script>
